import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import {
  getUserAddressSelector,
  getMyJLContentIndexSelector,
  getMyJLMemberStatusSelector,
  getMyJLModalOpenSelector,
} from '@redux/reducers/create-account/createAccountSelector';
import { getSessionExpiredAnnouncedSelector } from '@redux/reducers/app/appSelector';
import { getSessionIdSelector } from '@redux/reducers/bff/bffSelector';
import { isInternational } from '@redux/reducers/payment/orderFormReducer';
import { isApps } from '@redux/reducers/app/appReducer';
import shouldShowFullScreenSignUp from '@utils/myjl/fullScreenSignUp';

const getIsInternationalSelector = (state: RootState) => isInternational(state);
const getIsAppsSelector = (state: RootState) => isApps(state);
const getShouldShowFullScreenSignUpSelector = (state: RootState) => shouldShowFullScreenSignUp(state);

export default createSelector(
  [
    getUserAddressSelector,
    getMyJLContentIndexSelector,
    getMyJLMemberStatusSelector,
    getSessionExpiredAnnouncedSelector,
    getSessionIdSelector,
    getIsInternationalSelector,
    getIsAppsSelector,
    getMyJLModalOpenSelector,
    getShouldShowFullScreenSignUpSelector,
  ],
  (
    userAddress,
    myJLContentIndex,
    myJLMemberStatus,
    sessionExpiredAnnounced,
    sessionId,
    isInternationalAddress,
    isApps,
    myJLModalOpen,
    showFullScreenSignup,
  ) => ({
    userAddress,
    myJLContentIndex,
    myJLMemberStatus,
    sessionExpiredAnnounced,
    sessionId,
    isInternationalAddress,
    isApps,
    showMyJLModal: myJLModalOpen && !showFullScreenSignup,
    showFullScreenSignup,
  }),
);
